<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-card
    class="mt-1"
    elevation="0"
  >
    <v-card-text>
      <h1>{{ lastName.trim() }} {{ firstName.trim() }}</h1>
      <p class="mt-2">
        {{ addressLine1 }}
        <template v-if="addressLine2">
          {{ addressLine2 }}<br>
        </template>

        {{ city }} {{ plz }}<br>
        <span class="font-weight-bold">{{ $t('email') }} </span>{{ email }}<br>
        <span class="font-weight-bold">{{ $t('phone') }} </span>{{ tel }}<br>
        <span class="font-weight-bold">{{ $t('lieferzeit') }} </span>{{ date }} {{ time }}<br>
        {{ note }}
      </p>
      <v-chip v-if="deliveryMethod">
        {{ deliveryMethod }}
      </v-chip>
      <v-chip v-if="reason">
        {{ reason }}
      </v-chip>
    </v-card-text>
  </v-card>
</template>

<script>
  const DefaultAddressInfo = {
    lastName: '',
    firstName: '',
    reason: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    plz: '',
    tel: '',
    email: '',
    date: '',
    time: '',
    note: '',
    deliveryMethod: '',
  }
  export default {
    name: 'AddressInfoBlock',
    props: {
      addressInfo: {
        type: Object,
        default: () => DefaultAddressInfo,
      },
    },
    data: function () {
      return Object.assign({}, DefaultAddressInfo, this.addressInfo)
    },
  }
</script>

<style scoped>

</style>
